import {
  DefenseArmStatusTypes,
  DefenseEventTypes,
  IDefenseEventNotifyAreaArmStatusProps,
} from '../../../../services/Defense/Events/types';
import TableComponent, {
  IColumnProps,
} from '../../../../components/TableComponent';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import {
  convertArmStatus,
  convertEventType,
} from '../../../../converters/Defense/ConverterDefense';
import React from 'react';
import dayjs from 'dayjs';
import DateFieldComponent from '../../../../components/DateFieldComponent';

interface IDefenseNotifyAreaArmStatusContentProps {
  event: IDefenseEventNotifyAreaArmStatusProps;
}

const DefenseNotifyAreaArmStatusContent = ({
  event,
}: IDefenseNotifyAreaArmStatusContentProps) => {
  const columns: IColumnProps[] = [
    {
      id: 'id',
      label: 'ID',
      width: 'auto',
    },
    {
      id: 'device.id',
      label: 'ID do Dispositivo',
      width: 'auto',
    },
    {
      id: 'device.name',
      label: 'Nome do Dispositivo',
      width: 'auto',
    },
    {
      id: 'areaId',
      label: 'ID de Área',
      width: 'auto',
    },
    {
      id: 'armStatus',
      label: 'Status',
      width: 'auto',
      render: (armStatus: string) => {
        return <>{convertArmStatus(armStatus as DefenseArmStatusTypes)}</>;
      },
    },
  ];

  const formatCreatedAt = (date: Date) => {
    return dayjs(date, 'YYYY/MM/DD HH:mm:ss');
  };

  return (
    <Grid2
      container
      direction="row"
      spacing={2}
      justifyContent={'center'}
      alignItems={'center'}
      size={12}
    >
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Dispositivo"
          value={event?.device?.name ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo"
          value={
            convertEventType(event.type as DefenseEventTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }} mb={3}>
        <DateFieldComponent
          label="Data/Hora"
          value={formatCreatedAt(event.createdAt)}
          readOnly={true}
        />
        <TextFieldComponent
          label="Descrição"
          value={event.description ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
      </Grid2>
      <TableComponent title={'Áreas'} rows={event.areas} columns={columns} />
    </Grid2>
  );
};

export default DefenseNotifyAreaArmStatusContent;
